import { purchaseOrderIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const getPurchaseOrderTags = {
  name: "getPurchaseOrderTags" as const,
  input: z.object({ purchaseOrderIds: z.array(purchaseOrderIdFormat.schema) }),
  output: z.object({ tags: z.array(z.string()) }),
};
